<template>
  <div class="source_detail">
    <header class="source_detail_head">
      <div class="source_detail_title_wrap">
        <span class="source_detail_title_icon">详</span>
        <div>
          <h1 class="source_detail_title">货源详情</h1>
          <div class="source_detail_subtitle">
            <span>货源编号 {{ form.mainOrderNumber }}</span>
            <span>托运人：{{ showText(form.createdByName) }}</span>
          </div>
        </div>
      </div>
      <button
        type="button"
        class="source_detail_close"
        aria-label="关闭"
        @click="closeDetail"
      >
        ×
      </button>
    </header>

    <div class="source_detail_scroll">
      <section class="source_detail_section">
        <div class="source_detail_section_title">
          <h2>车货信息</h2>
        </div>
        <div class="source_detail_section_body">
          <div class="delivery_card">
            <div class="endpoint_route">
              <article class="endpoint_card">
                <div class="endpoint_head">
                  <div class="endpoint_title">
                    <span class="endpoint_badge">发</span>
                    <span>发货信息</span>
                  </div>
                </div>
                <div class="endpoint_address">
                  <span>发货企业名称</span>
                  <strong>{{ form.consignorCompanyName || "--" }}</strong>
                </div>
                <div class="endpoint_address">
                  <span>发货地址</span>
                  <strong>{{ shipperAddressText }}</strong>
                </div>
                <div class="endpoint_contact">
                  <span>发货联系人</span>
                  <strong>{{ showText(form.shipperName) }}</strong>
                  <i />
                  <strong>{{ showText(form.shipperPhone) }}</strong>
                </div>
              </article>
              <div class="route_connector" aria-hidden="true" />
              <article class="endpoint_card endpoint_card_unload">
                <div class="endpoint_head">
                  <div class="endpoint_title">
                    <span class="endpoint_badge">卸</span>
                    <span>卸货信息</span>
                  </div>
                </div>
                <div class="endpoint_address">
                  <span>收货企业名称</span>
                  <strong>{{ form.consigneeCompanyName || "--" }}</strong>
                </div>
                <div class="endpoint_address">
                  <span>卸货地址</span>
                  <strong>{{ consigneeAddressText }}</strong>
                </div>
                <div class="endpoint_contact">
                  <span>卸货联系人</span>
                  <strong>{{ showText(form.consigneeName) }}</strong>
                  <i />
                  <strong>{{ showText(form.consigneePhone) }}</strong>
                </div>
              </article>
            </div>
            <div class="delivery_meta_row">
              <div
                class="validity_strip"
                :class="{ validity_strip_one_car: isOneCar }"
              >
                <template v-if="isOneCar">
                  <div class="time_item">
                    <span>装车时间</span>
                    <strong>{{ showText(form.lastLoadingTime) }}</strong>
                  </div>
                  <div class="time_item">
                    <span>卸车时间</span>
                    <strong>{{ showText(form.lastUnloadingTime) }}</strong>
                  </div>
                </template>
                <div v-else-if="isMultiCar" class="time_item">
                  <span>货源有效期</span>
                  <strong>{{ showText(form.lastUnloadingTime) }}</strong>
                </div>
              </div>
              <div class="route_summary">
                <div class="route_stat">
                  <span>里程</span>
                  <strong>{{ distanceText }}</strong>
                </div>
                <div class="route_stat">
                  <span>预计</span>
                  <strong>{{ form.takeTime }}小时</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="cargo_summary_card">
            <div class="cargo_facts">
              <div class="cargo_fact">
                <span>货物名称</span>
                <strong class="cargo_fact_main">{{
                  showText(form.coalTypeName)
                }}</strong>
              </div>
              <div class="cargo_fact">
                <span>货物数量</span>
                <strong>
                  {{ showText(form.weight) }}
                  <em>{{ showText(form.coalUnitName) }}</em>
                </strong>
              </div>
              <div class="cargo_fact">
                <span>运输方式</span>
                <strong>{{ transportTypeName }}</strong>
              </div>
              <div class="cargo_fact">
                <span>用车数量</span>
                <strong>
                  {{ showText(form.coalNumber) }}
                  <em v-if="vehicleCountNumber !== null">辆</em>
                </strong>
              </div>
              <div class="cargo_fact">
                <span>用车要求</span>
                <strong class="vehicle_demand">{{
                  showText(form.pushVehicleUse)
                }}</strong>
              </div>
            </div>
            <div class="cargo_extra_facts">
              <div class="cargo_extra_fact">
                <span>货物单价</span>
                <strong>{{ coalPriceText }}</strong>
              </div>
              <div class="cargo_extra_fact">
                <span>合理损耗</span>
                <strong>{{ wastageText }}</strong>
              </div>
              <div class="cargo_extra_fact">
                <span>浮动费用</span>
                <strong class="float_value">{{
                  showMoney(form.driftPrice)
                }}</strong>
              </div>
              <div class="cargo_extra_fact">
                <span>运费抹零</span>
                <strong>{{ freightRoundingName }}</strong>
              </div>
              <div class="cargo_extra_fact">
                <span>接单方式</span>
                <strong class="receive_summary">
                  {{ receiveMethodName }}
                  <small
                    v-if="isSmartRecommendDriver && form.pushTargetName"
                    class="inline_driver"
                    >{{ form.pushTargetName }}</small
                  >
                </strong>
              </div>
            </div>
            <div v-if="form.vendorName" class="vendor_line">
              <span>供应商</span>
              <strong>{{ form.vendorName }}</strong>
            </div>
            <div class="cargo_requirements_row">
              <span class="transport_requirement">
                运输要求<b>{{ showText(form.coalName) }}</b>
              </span>
              <span class="receipt_upload">
                <input
                  type="checkbox"
                  disabled
                  aria-label="需要司机上传回单"
                  :checked="form.isOrderReturn == '1'"
                />
                <span>需要司机上传回单</span>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section class="source_detail_section">
        <div class="source_detail_section_title">
          <h2>费用信息</h2>
        </div>
        <div class="source_detail_section_body">
          <div
            class="fee_layout"
            :class="{ fee_layout_single: !(form.oilFee > 0) }"
          >
            <div class="fee_block">
              <div class="fee_caption">费用信息（预估）</div>
              <div class="fee_row">
                <span>运费单价</span>
                <b>{{ freightPriceText }}</b>
              </div>
              <div class="fee_row">
                <span>预估司机运费</span>
                <b class="fee_blue">{{ showMoney(form.dirverEstimatePay) }}</b>
              </div>
              <div class="fee_row">
                <span>平台服务费</span>
                <b class="fee_orange">{{ showMoney(form.serInfoPay) }}</b>
              </div>
              <div class="fee_row fee_row_total">
                <span>预估托运人运费</span>
                <b class="fee_orange">{{
                  showMoney(form.shipperEstimatePay)
                }}</b>
              </div>
              <div class="payment_line">
                <span>付款方式</span>
                <span
                  class="pay_tag"
                  :class="{ pay_tag_on: form.payType == '1' }"
                  >预付 {{ showMoney(form.prePay) }}</span
                >
                <span
                  class="pay_tag pay_tag_arrive"
                  :class="{ pay_tag_on: form.arrivePayType == '1' }"
                  >到付 {{ showMoney(form.arrivePay) }}</span
                >
                <span
                  class="pay_tag pay_tag_return"
                  :class="{ pay_tag_on: form.returnPayType == '1' }"
                  >回单付 {{ showMoney(form.returnPay) }}</span
                >
              </div>
            </div>
            <div v-if="form.oilFee > 0" class="fee_block">
              <div class="fee_caption fee_caption_green">增值服务</div>
              <div class="service_line service_line_energy">
                <span>能源配额</span>
                <span class="fee_value_stack">
                  <b class="energy_value"
                    >{{ showMoney(form.oilFee) }}({{ form.oilFeeRatio }}%)</b
                  >
                  <small
                    >预估优惠金额
                    {{ showMoney(form.discountServiceFee) }}</small
                  >
                </span>
              </div>

              <!-- <div class="service_line">
                <span>保价</span>
                <b class="service_value">TODO</b>
              </div>
              <div class="service_line">
                <span>保费</span>
                <b class="service_value">TODO</b>
              </div> -->
            </div>
          </div>
        </div>
      </section>

      <section v-if="form.qrCodeOnOff == '1'" class="source_detail_section">
        <div class="source_detail_section_title">
          <h2>货源二维码</h2>
        </div>
        <div class="source_detail_section_body qr_body">
          <div class="qr_item">
            <vue-easy-print ref="loadingQrPrint" table-show>
              <div class="img_box">
                <div class="qr_code_title">装货二维码</div>
                <el-image
                  style="width: 300px; height: 300px"
                  :src="form.loadingQr"
                  :preview-src-list="[form.loadingQr]"
                />
              </div>
            </vue-easy-print>
            <el-button @click="printLoadingQrBtn()">打印</el-button>
          </div>
          <div class="qr_item">
            <vue-easy-print ref="unloadingQrPrint" table-show>
              <div class="img_box">
                <div class="qr_code_title">卸货二维码</div>
                <el-image
                  style="width: 300px; height: 300px"
                  :src="form.unloadingQr"
                  :preview-src-list="[form.unloadingQr]"
                />
              </div>
            </vue-easy-print>
            <el-button @click="printUnloadingQrBtn()">打印</el-button>
          </div>
        </div>
      </section>

      <section class="source_detail_section">
        <div class="progress_zone">
          <div class="progress_top">
            <b>运输单生成进度</b>
            <span
              >已生成 {{ listQuery.total || 0 }} /
              {{ showText(form.coalNumber) }} 单</span
            >
          </div>
          <div class="progress_track">
            <i :style="{ width: progressBarWidth }" />
          </div>
          <div class="progress_meta">
            <span
              >当前进度 <strong>{{ progressPercentText }}</strong></span
            >
            <span v-if="progressRemain !== null"
              >还差 {{ progressRemain }} 位司机接单</span
            >
            <!-- <span v-else>TODO</span> -->
          </div>
        </div>
        <div class="detail_tabs" role="tablist">
          <button
            type="button"
            class="detail_tab"
            :class="{ detail_tab_active: detailTab === 'orders' }"
            @click="detailTab = 'orders'"
          >
            运输单信息
            <span class="tab_count">{{ listQuery.total || 0 }}</span>
          </button>
          <button
            type="button"
            class="detail_tab"
            :class="{ detail_tab_active: detailTab === 'logs' }"
            @click="detailTab = 'logs'"
          >
            操作日志
            <span class="tab_count">{{ logTotal }}</span>
          </button>
        </div>
        <div v-show="detailTab === 'orders'" class="table_wrap">
          <vxe-table
            class="source_detail_table"
            border
            show-header-overflow
            show-overflow
            highlight-hover-row
            :data="tableData"
          >
            <vxe-table-column
              field="orderCode"
              title="运单单号"
              show-header-overflow
              show-overflow
              min-width="200"
              sortable
            />
            <vxe-table-column
              field="vehicleLicense"
              min-width="120"
              title="车牌号"
            />
            <vxe-table-column field="driverName" min-width="120" title="司机" />
            <vxe-table-column
              field="driverPhone"
              min-width="120"
              title="司机电话"
            >
              <template v-slot="{ row }">
                <div>
                  {{ row.teamPhone ? row.teamPhone : row.driverPhone }}
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="gmtCreated"
              min-width="200"
              title="接单时间"
            />
            <vxe-table-column
              field="fillTime"
              min-width="200"
              title="装货时间"
            />
            <vxe-table-column
              field="signTime"
              min-width="200"
              title="签收时间"
            />
            <vxe-table-column
              field="status"
              :formatter="formatterStatus"
              title="订单状态"
              min-width="130"
              sortable
            />
            <vxe-table-column
              field="deleted"
              :formatter="formatterDeleted"
              title="取消状态"
              min-width="130"
              sortable
            />
            <vxe-table-column title="操作" min-width="50" fixed="right">
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="详情"
                  placement="top"
                >
                  <vxe-button
                    type="text"
                    @click="orderDesil(scope.row.code, scope.row)"
                  >
                    <i class="el-icon-document" />
                  </vxe-button>
                </el-tooltip>
              </template>
            </vxe-table-column>
          </vxe-table>
          <vxe-pager
            :page-sizes="Pagingconf"
            :current-page.sync="listQuery.pageNum"
            :page-size.sync="listQuery.pageSize"
            :total="listQuery.total"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'Number',
              'NextPage',
              'NextJump',
              'Sizes',
              'FullJump',
              'Total'
            ]"
            @page-change="handlePageChange"
          />
        </div>
        <div v-if="detailTab === 'logs'" class="table_wrap">
          <table class="log_table">
            <thead>
              <tr>
                <th>操作人</th>
                <th>操作时间</th>
                <th>操作内容</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!logList.length">
                <td class="log_empty" colspan="3">暂无操作日志</td>
              </tr>
              <tr v-for="(row, index) in logList" :key="row.operId || index">
                <td>
                  <span class="log_user">
                    <i class="log_user_dot">{{ operInitial(row.operName) }}</i>
                    {{ row.operName }}
                  </span>
                </td>
                <td>{{ row.operTime }}</td>
                <td class="log_content">
                  {{ row.msg }}
                  <span v-if="row.title" class="log_badge">{{
                    row.title
                  }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <vxe-pager
            :current-page.sync="logQuery.pageNum"
            :page-size.sync="logQuery.pageSize"
            :total="logTotal"
            :layouts="['PrevPage', 'Number', 'NextPage', 'Total']"
            @page-change="handleLogPageChange"
          />
        </div>
      </section>
    </div>

    <vxe-modal
      v-model="tuteship"
      title="运输单详情"
      width="1000"
      height="700"
      resize
    >
      <!-- orderInfo="" -->
      <ordergoods ref="detailRef" :order-info="orderInfo" />
    </vxe-modal>
  </div>
</template>
<script>
// import { regionDataPlus } from 'element-china-area-data'
import ordergoods from "@/components/WaybillDetails";
import {
  OrderDetails,
  insuranceType,
  isTreeOpen,
  isRainbowOn
} from "@/api/orderform";
import { orderDetailList } from "@/api/transport";
import { list as operLogList } from "@/api/operLog";
import vueEasyPrint from "vue-easy-print";
import { getListDict } from "@/api/shipment";
export default {
  components: {
    vueEasyPrint,
    ordergoods
  },
  data() {
    return {
      orderInfo: {},
      detailTab: "orders",
      sourceCode: "",
      logTotal: 0,
      logList: [],
      logQuery: {
        pageNum: 1,
        pageSize: 10
      },
      optionsfreightRoundingType: [
        {
          code: 0,
          name: "保留小数"
        },
        {
          code: 1,
          name: "抹除小数"
        },
        {
          code: 2,
          name: "抹除个位"
        },
        {
          code: 3,
          name: "抹除十位"
        },
        {
          code: 4,
          name: "向下取整到5的倍数"
        }
      ],
      rainbowOnOff: true,
      optionsTs: [],
      tuteship: false,
      hasTreeOpen: "",
      listQuery: {
        mainOrderCode: "",
        isCancel: "",
        pageNum: 1,
        pageSize: 20,
        total: 0
      },
      Pagingconf: [],
      form: {
        name: "",
        createdByName: "",
        consigneeAddress: "",
        consigneeDetailAddress: "",
        gmtCreated: "",
        gmtModified: "",
        dfName: "",
        dfPhone: "",
        shipperAddress: "",
        shipperDetailAddress: "",
        shipperName: "",
        shipperPhone: "",
        coalBigTypeName: "",
        coalUnitName: "",
        isQuote: "0",
        isRainbowOn: 0,
        loadingQr: "",
        unloadingQr: "",
        qrCodeOnOff: ""
      },
      branchCode: "",
      tableData: [],
      carneme: [],
      instype: {
        type: "insureType1"
      }
    };
  },
  computed: {
    vehicleCountNumber() {
      const n = Number(this.form.coalNumber);
      if (!Number.isFinite(n)) return null;
      return n;
    },
    isOneCar() {
      return this.vehicleCountNumber !== null && this.vehicleCountNumber < 2;
    },
    isMultiCar() {
      return this.vehicleCountNumber !== null && this.vehicleCountNumber > 1;
    },
    progressPercentText() {
      if (this.vehicleCountNumber === null || this.vehicleCountNumber <= 0) {
        return "TODO";
      }
      const total = Number(this.listQuery.total) || 0;
      const percent = Math.min((total / this.vehicleCountNumber) * 100, 100);
      return percent.toFixed(1) + "%";
    },
    progressBarWidth() {
      if (this.progressPercentText === "TODO") return "0%";
      return this.progressPercentText;
    },
    progressRemain() {
      if (this.vehicleCountNumber === null || this.vehicleCountNumber <= 0) {
        return null;
      }
      const total = Number(this.listQuery.total) || 0;
      return Math.max(this.vehicleCountNumber - total, 0);
    },
    shipperAddressText() {
      return [this.form.shipperAddress, this.form.shipperDetailAddress]
        .filter(item => item)
        .join(" ");
    },
    consigneeAddressText() {
      return [this.form.consigneeAddress, this.form.consigneeDetailAddress]
        .filter(item => item)
        .join(" ");
    },
    distanceText() {
      const value = this.form.distance;
      if (value === undefined || value === null || value === "") return "";
      const text = String(value);
      if (/km|公里/i.test(text)) return text;
      return text + " km";
    },
    transportTypeName() {
      const current = this.form.transportType;
      const item = (this.optionsTs || []).find(
        option =>
          option.code === current || String(option.code) === String(current)
      );
      return item ? item.name : this.showText(current);
    },
    freightRoundingName() {
      const current = this.form.freightRoundingType;
      if (current === undefined || current === null || current === "")
        return "";
      const item = this.optionsfreightRoundingType.find(
        option => option.code === current || option.code === Number(current)
      );
      return item ? item.name : "";
    },
    coalUnitPriceName() {
      const map = { 0: "元/吨", 1: "元/方", 2: "元/件" };
      const current = this.form.coalUnit;
      if (current === undefined || current === null || current === "")
        return "";
      if (map[current] != null) return map[current];
      if (map[Number(current)] != null) return map[Number(current)];
      return "";
    },
    coalPriceText() {
      const price = this.showMoney(this.form.coalPrice);
      if (!price && !this.coalUnitPriceName) return "";
      return [price, this.coalUnitPriceName].filter(Boolean).join(" ");
    },
    wastageText() {
      return [
        this.showText(this.form.limitWastageAmount),
        this.showText(this.form.limitWastageTypeName)
      ]
        .filter(item => item !== "")
        .join(" ");
    },
    freightPriceText() {
      const price = this.showMoney(this.form.price);
      const unit = this.showText(this.form.isTrunkName);
      return price + unit;
    },
    isSmartRecommendDriver() {
      return this.receiveMethodCode === 0 && !!this.form.pushTarget;
    },
    receiveMethodCode() {
      const raw = this.form.receiveOrderMethod;
      if (raw === undefined || raw === null || raw === "") return null;
      const method = Number(raw);
      return Number.isFinite(method) ? method : null;
    },
    receiveMethodName() {
      if (this.isSmartRecommendDriver) return "智能推荐";
      if (this.receiveMethodCode === 1) return "仅扫码接单";
      if (this.receiveMethodCode === 0 && !this.form.pushTarget) {
        return "发布至大厅";
      }
      return "";
    }
  },
  created() {
    this.getDict();
    this.getRainbowOnOrOff();
    isTreeOpen().then(res => {
      this.hasTreeOpen = res.data;
    });
  },
  mounted() {},
  methods: {
    showText(val) {
      if (val === 0 || val === "0") return val;
      if (val === undefined || val === null || val === "") return "";
      return val;
    },
    showMoney(val) {
      const text = this.showText(val);
      if (text === "") return "";
      return "￥" + text;
    },
    closeDetail() {
      this.$emit("close");
    },
    // 云平台选择开关
    getRainbowOnOrOff() {
      isRainbowOn({ branchCode: this.branchCode }).then(res => {
        this.rainbowOnOff = res.data;
      });
    },
    getDict() {
      getListDict({ types: "transportType" }).then(response => {
        this.optionsTs = response.data[0].dictList;
      });
    },
    Getdetails(code) {
      this.detailTab = "orders";
      this.sourceCode = code;
      this.logQuery.pageNum = 1;
      this.loadOperLog();
      this.listQuery.mainOrderCode = code;
      OrderDetails(code).then(response => {
        this.form = response.data;
        this.form.coalNumber = response.data.coalNumber || "不限";
        this.form.coalName = response.data.coalName || "暂无";
        this.branchCode = response.data.order.branchCode;
        this.Insurance();
      });
      this.findList();
    },
    loadOperLog() {
      if (!this.sourceCode) {
        this.logTotal = 0;
        this.logList = [];
        return;
      }
      operLogList({
        pageNum: this.logQuery.pageNum,
        pageSize: this.logQuery.pageSize,
        reviewCode: this.sourceCode,
        businessType: 7
      }).then(response => {
        this.logList = response.data.records || [];
        this.logTotal = response.data.total || 0;
      });
    },
    handleLogPageChange({ currentPage, pageSize }) {
      this.logQuery.pageNum = currentPage;
      this.logQuery.pageSize = pageSize;
      this.loadOperLog();
    },
    operInitial(name) {
      const text = name ? String(name).trim() : "";
      return text ? text.slice(0, 1) : "";
    },
    findList() {
      orderDetailList(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total
          ? (this.Pagingconf = [20, 30, 50, 100, response.data.total])
          : (this.Pagingconf = [20, 30, 50, 100]);
      });
    },
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    orderDesil(c, row) {
      this.orderInfo = row;
      this.$refs.detailRef.Getdetails(c);
      this.tuteship = true;
    },
    printLoadingQrBtn() {
      this.$refs.loadingQrPrint.print();
    },
    printUnloadingQrBtn() {
      this.$refs.unloadingQrPrint.print();
    },
    formatterDeleted({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未取消";
        case 1:
          return "已取消";
        default:
          break;
      }
    },
    // 订单状态（与运单管理 statusOptions 一致）
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未接单";
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已核算";
        case 5:
          return "部分支付";
        case 6:
          return "已打款";
        default:
          break;
      }
    },
    // 查询保险
    Insurance() {
      if (this.branchCode) {
        this.instype.branchCode = this.branchCode;
        insuranceType(this.instype).then(response => {
          this.carneme = response.data.records;
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.source_detail {
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: #fff;
  color: #24324a;
  font-size: 14px;
  line-height: 1.5;
}

.source_detail_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 0 0 auto;
  min-height: 68px;
  padding: 0 22px;
  border-bottom: 1px solid #dfe6ef;
  background: linear-gradient(180deg, #fff, #fcfdff);
}

.source_detail_title_wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.source_detail_title_icon {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border-radius: 10px;
  background: linear-gradient(145deg, #edf4ff, #e6efff);
  color: #2f6ff3;
  font-size: 17px;
  font-weight: 800;
}

.source_detail_title {
  margin: 0;
  color: #24324a;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.3;
}

.source_detail_subtitle {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 3px;
  color: #8491a3;
  font-size: 12px;
}

.source_detail_status {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border: 1px solid #d7e0eb;
  border-radius: 10px;
  background: #f7f9fc;
  color: #8491a3;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.5;
}

.source_detail_close {
  display: grid;
  width: 34px;
  height: 34px;
  place-items: center;
  border: 1px solid #e4e9f0;
  border-radius: 9px;
  background: #f8fafc;
  color: #6f7c8f;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.source_detail_close:hover {
  border-color: #b8caf0;
  background: #f2f6ff;
  color: #2f6ff3;
}

.source_detail_scroll {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 16px 20px 22px;
  background: #f7f9fc;
}

.source_detail_section {
  overflow: hidden;
  margin-bottom: 14px;
  border: 1px solid #dfe6ef;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(24, 49, 82, 0.035);
}

.source_detail_section:last-child {
  margin-bottom: 0;
}

.source_detail_section_title {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 15px;
  border-bottom: 1px solid #dfe6ef;
  background: linear-gradient(180deg, #fff, #fbfcfe);
}

.source_detail_section_title h2 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: #24324a;
  font-size: 15px;
  font-weight: 700;
}

.source_detail_section_title h2:before {
  content: "";
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #2f6ff3;
}

.source_detail_section_body {
  padding: 14px 15px 16px;
}

.delivery_card {
  overflow: hidden;
  border: 1px solid #dce5f0;
  border-radius: 11px;
  background: #fff;
}

.endpoint_route {
  display: grid;
  grid-template-columns: 1fr 56px 1fr;
  align-items: stretch;
  padding: 10px 12px;
  background: #fbfcfe;
}

.endpoint_card {
  min-width: 0;
  padding: 13px 16px;
}

.endpoint_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 10px;
}

.endpoint_title {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #35465e;
  font-size: 14px;
  font-weight: 700;
}

.endpoint_badge {
  display: grid;
  width: 25px;
  height: 25px;
  place-items: center;
  border-radius: 7px;
  background: #eaf2ff;
  color: #2f6ff3;
  font-size: 12px;
  font-weight: 800;
}

.endpoint_card_unload .endpoint_badge {
  background: #eaf8f1;
  color: #16ac67;
}

.endpoint_address {
  display: grid;
  grid-template-columns: 88px 1fr;
  align-items: start;
  gap: 8px;
}

.endpoint_address + .endpoint_address {
  margin-top: 6px;
}

.endpoint_address span,
.endpoint_contact span {
  color: #8290a3;
  font-size: 12px;
  line-height: 1.5;
}

.endpoint_address strong,
.endpoint_contact strong {
  color: #2f4058;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}

.endpoint_contact {
  display: grid;
  grid-template-columns: 88px max-content 1px max-content;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px dashed #e3e9f1;
}

.endpoint_contact strong {
  color: #53647a;
}

.endpoint_contact i {
  width: 1px;
  height: 12px;
  background: #dfe5ed;
}

.route_connector {
  position: relative;
}

.route_connector:before {
  content: "";
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
  height: 1px;
  background: #cfdae8;
}

.route_connector:after {
  content: "";
  position: absolute;
  top: calc(50% - 4px);
  right: 1px;
  width: 7px;
  height: 7px;
  border-top: 1px solid #9dafc4;
  border-right: 1px solid #9dafc4;
  transform: rotate(45deg);
}

.delivery_meta_row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  border-top: 1px solid #e3e9f1;
  background: #f8fafc;
}

.validity_strip {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  min-height: 42px;
  padding: 10px 14px;
}

.validity_strip_one_car {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.time_item {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.time_item + .time_item {
  margin-left: 14px;
  padding-left: 14px;
  border-left: 1px solid #dfe6ef;
}

.time_item span,
.route_stat span {
  color: #8290a3;
  font-size: 12px;
  line-height: 1.4;
}

.time_item strong,
.route_stat strong {
  color: #2f4058;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  white-space: nowrap;
}

.route_summary {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  padding: 10px 8px;
  border-left: 1px solid #e1e7ef;
}

.route_stat {
  min-width: 118px;
  padding: 0 18px;
}

.route_stat + .route_stat {
  border-left: 1px solid #e2e8f0;
}

.cargo_summary_card {
  overflow: hidden;
  margin-top: 12px;
  border: 1px solid #dce5f0;
  border-radius: 11px;
  background: #fff;
}

.cargo_facts,
.cargo_extra_facts {
  display: grid;
  align-items: start;
  padding: 18px 20px;
}

.cargo_facts {
  grid-template-columns: 1.25fr 0.7fr 0.85fr 0.65fr 1.45fr;
}

.cargo_extra_facts {
  grid-template-columns: 0.8fr 0.8fr 0.8fr 0.8fr 1.8fr;
  border-top: 1px solid #e7edf4;
}

.cargo_fact,
.cargo_extra_fact {
  min-width: 0;
  padding: 0 15px;
  border-left: 1px solid #edf1f6;
}

.cargo_fact:first-child,
.cargo_extra_fact:first-child {
  padding-left: 0;
  border-left: 0;
}

.cargo_fact span,
.cargo_extra_fact span,
.vendor_line span {
  display: block;
  margin-bottom: 5px;
  color: #8290a3;
  font-size: 12px;
  line-height: 1.4;
}

.cargo_fact strong,
.cargo_extra_fact strong,
.vendor_line strong {
  display: block;
  overflow: hidden;
  color: #2f4058;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cargo_fact_main,
.vehicle_demand,
.receive_summary {
  overflow: visible;
  white-space: normal;
}

.cargo_fact em,
.cargo_extra_fact em {
  margin-left: 3px;
  color: inherit;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
}

.cargo_extra_fact strong.float_value {
  color: #e16b0d;
}

.inline_driver {
  display: inline;
  margin-left: 7px;
  color: #6e86aa;
  font-size: 11px;
  font-weight: 500;
  line-height: 1.4;
}

.vendor_line {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  border-top: 1px solid #e7edf4;
}

.vendor_line span {
  margin-bottom: 0;
}

.vendor_line strong {
  display: inline;
}

.cargo_requirements_row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 42px;
  padding: 0 20px;
  border-top: 1px solid #e7edf4;
}

.transport_requirement,
.receipt_upload {
  display: flex;
  min-height: 42px;
  align-items: center;
  padding: 9px 0;
  color: #8290a3;
  font-size: 12px;
}

.transport_requirement b {
  margin-left: 8px;
  color: #425269;
  font-size: 14px;
  font-weight: 600;
}

.receipt_upload {
  gap: 10px;
  color: #425269;
  font-size: 14px;
  font-weight: 600;
}

.receipt_upload input {
  width: 16px;
  height: 16px;
  margin: 0;
  pointer-events: none;
}

.fee_layout {
  display: grid;
  grid-template-columns: 1.08fr 0.92fr;
  border: 1px solid #e1e7ef;
  border-radius: 10px;
  background: #fff;
}

.fee_layout_single {
  grid-template-columns: 1fr;
}

.fee_layout_single .fee_block:first-child {
  border-right: 0;
}

.fee_block {
  padding: 14px 17px;
}

.fee_block:first-child {
  border-right: 1px solid #e3e9f0;
}

.fee_caption {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
  color: #35465e;
  font-size: 14px;
  font-weight: 700;
}

.fee_caption:before {
  content: "";
  width: 3px;
  height: 16px;
  border-radius: 2px;
  background: #f27918;
}

.fee_caption_green {
  margin-top: 13px;
}

.fee_caption_green:before {
  background: #16ac67;
}

.fee_row,
.service_line {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  min-height: 38px;
  padding: 8px 0;
  border-bottom: 1px dashed #e8edf3;
  color: #8290a3;
  font-size: 12px;
  line-height: 1.45;
}

.fee_row:last-child,
.service_line:last-child {
  border-bottom: 0;
}

.fee_row b,
.service_line b {
  color: #2f4058;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  text-align: right;
}

.fee_row_total {
  border-bottom: 0;
}

.fee_row_total b {
  font-size: 18px;
  font-weight: 700;
}

.fee_row b.fee_blue,
.service_line b.service_value {
  color: #2f6ff3;
}

.fee_row b.fee_orange,
.service_line b.energy_value {
  color: #ef6907;
}

.fee_value_stack {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.fee_value_stack small {
  margin-top: 1px;
  color: #9aa5b3;
  font-size: 11px;
  font-weight: 400;
}

.payment_line {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.payment_line > span:first-child {
  margin-right: 3px;
  color: #8290a3;
  font-size: 12px;
}

.pay_tag {
  padding: 5px 11px;
  border: 1px solid #d9e2ed;
  border-radius: 6px;
  background: #f7f9fc;
  color: #8d99a9;
  font-size: 12px;
}

.pay_tag_on {
  border-color: #d9e6ff;
  background: #edf4ff;
  color: #2f70ed;
}

.pay_tag_arrive.pay_tag_on {
  border-color: #ffe0bf;
  background: #fff3e8;
  color: #e6710b;
}

.pay_tag_return.pay_tag_on {
  border-color: #d9e6ff;
  background: #edf4ff;
  color: #2f70ed;
}

.progress_zone {
  padding: 14px 16px 12px;
  border-bottom: 1px solid #e7ecf2;
  background: linear-gradient(90deg, #f7faff, #fbfdff);
}

.progress_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.progress_top b {
  color: #3d4e67;
}

.progress_top span,
.progress_meta {
  color: #718197;
  font-size: 12px;
}

.progress_track {
  height: 7px;
  overflow: hidden;
  border-radius: 8px;
  background: #e8edf4;
}

.progress_track i {
  display: block;
  height: 100%;
  border-radius: 8px;
  background: linear-gradient(90deg, #3474f4, #76a4ff);
}

.progress_meta {
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  font-size: 11px;
}

.progress_meta strong {
  color: #2f6ff3;
}

.detail_tabs {
  display: flex;
  height: 46px;
  align-items: flex-end;
  gap: 28px;
  padding: 0 17px;
  border-bottom: 1px solid #dfe6ef;
  background: #fff;
}

.detail_tab {
  position: relative;
  height: 45px;
  padding: 0 3px;
  border: 0;
  background: transparent;
  color: #68778d;
  font-weight: 600;
  cursor: pointer;
}

.detail_tab_active {
  color: #2f6ff3;
}

.detail_tab_active:after {
  content: "";
  position: absolute;
  right: 0;
  bottom: -1px;
  left: 0;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #2f6ff3;
}

.tab_count {
  margin-left: 5px;
  padding: 1px 6px;
  border-radius: 9px;
  background: #eef2f7;
  color: #8492a6;
  font-size: 10px;
}

.detail_tab_active .tab_count {
  background: #eaf2ff;
  color: #2f6ff3;
}

.table_wrap {
  padding: 13px 15px 16px;
}

.log_table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid #dfe6ef;
  border-radius: 9px;
  overflow: hidden;
}

.log_table th {
  height: 42px;
  padding: 0 12px;
  border-right: 1px solid #e1e7ef;
  border-bottom: 1px solid #dfe6ef;
  background: #f7f9fc;
  color: #607087;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.log_table th:nth-child(1) {
  width: 170px;
}

.log_table th:nth-child(2) {
  width: 210px;
}

.log_table td {
  height: 52px;
  padding: 8px 12px;
  border-right: 1px solid #edf1f5;
  border-bottom: 1px solid #edf1f5;
  color: #46566d;
}

.log_table th:last-child,
.log_table td:last-child {
  border-right: 0;
}

.log_table tbody tr:last-child td {
  border-bottom: 0;
}

.log_table tbody tr:hover td {
  background: #fafcff;
}

.log_user {
  display: flex;
  align-items: center;
  gap: 8px;
}

.log_user_dot {
  display: grid;
  width: 26px;
  height: 26px;
  place-items: center;
  border-radius: 50%;
  background: #eef4ff;
  color: #2f6ff3;
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.log_content {
  color: #34445c;
}

.log_badge {
  margin-left: 8px;
  padding: 2px 7px;
  border-radius: 9px;
  background: #f2f4f7;
  color: #7f8b9b;
  font-size: 10px;
  white-space: nowrap;
}

.log_empty {
  color: #8290a3;
  text-align: center;
}

.source_detail_table {
  ::v-deep .vxe-header--column {
    background: #f7f9fc;
    color: #607087;
    font-size: 12px;
    font-weight: 700;
  }

  ::v-deep .vxe-body--column {
    color: #46566d;
  }
}

.qr_body {
  display: flex;
  gap: 24px;
}

.qr_item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img_box {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.qr_code_title {
  margin-bottom: 8px;
  font-size: 18px;
}
</style>
<style lang="scss">
.source_detail_modal .vxe-modal--box {
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 24px 80px rgba(15, 31, 54, 0.24);
}

.source_detail_modal .vxe-modal--body {
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
}

.source_detail_modal .vxe-modal--content {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding: 0 !important;
  overflow: hidden;
}
</style>
